<button mat-icon-button type="button" [matMenuTriggerFor]="languages"
    [attr.aria-label]="activeLang === 'en' ? 'Language' : 'Sprache'"
    [matTooltip]="activeLang === 'en' ? 'Language' : 'Sprache'">
    <mat-icon color="primary" svgIcon="heroicons_outline:globe-alt"></mat-icon>
</button>
<mat-menu xPosition="before" #languages="matMenu">
    @for (lang of availableLangs; track trackByFn($index, lang)) {
        <button mat-menu-item role="menuitemradio" [attr.aria-checked]="activeLang === lang.id" (click)="setActiveLang(lang.id)">
            <mat-icon color="primary" svgIcon="heroicons_outline:check" [style.visibility]="activeLang === lang.id ? 'visible' : 'hidden'"></mat-icon>
            <span>{{ lang.id === 'de' ? 'Deutsch' : 'English' }}</span>
        </button>
    }
</mat-menu>
